import { Badge, Button, Card, Carousel, Collapse, Form } from "react-bootstrap";
import { useState } from "react";
import { NavLink } from "react-router-dom";

const SitePilotAddonsPreview = ({ singleSitePilotAddons }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="py-2">
      <Card className="border">
        {singleSitePilotAddons?.banners?.length > 0 && (
          <>
            {singleSitePilotAddons?.sliders ? (
              <Carousel
                interval={3000}
                indicators
                className="integration-carousel mb-3"
              >
                {singleSitePilotAddons?.banners?.map((icon, index) => (
                  <Carousel.Item key={index}>
                    <img
                      className="d-block w-100 rounded"
                      src={icon}
                      alt={`Slider ${index + 1}`}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            ) : (
              <div className="integration-carousel mb-3">
                <img
                  className="d-block w-100 rounded"
                  src={singleSitePilotAddons?.banners?.[0]}
                  alt="Slider"
                />
              </div>
            )}
          </>
        )}

        <Card.Body>
          {singleSitePilotAddons?.tags?.length > 0 && (
            <div className="hstack justify-content-between mb-2">
              <p
                style={{ fontSize: 14 }}
                className="text-muted m-0 hstack gap-1 flex-wrap"
              >
                <span className="fw-bold">Works With: </span>
                {singleSitePilotAddons?.tags?.map((tags, index) => (
                  <Badge className="rounded-1" key={index}>
                    {tags}
                  </Badge>
                ))}
              </p>
            </div>
          )}
          <div>
            <p
              style={{ fontSize: 13 }}
              dangerouslySetInnerHTML={{
                __html: singleSitePilotAddons?.overview,
              }}
            />
            {singleSitePilotAddons?.faqs?.length > 0 && (
              <>
                <p
                  style={{ fontSize: 14 }}
                  className="text-muted m-0 hstack gap-1 flex-wrap"
                >
                  <span className="fw-bold">FAQ </span>
                </p>
                {singleSitePilotAddons?.faqs?.map((faq, index) => {
                  const isActive = activeIndex === index;

                  return (
                    <div key={index} className="mb-2 border-bottom">
                      <div
                        className="d-flex align-items-center justify-content-betwee py-2"
                        onClick={() => toggleFAQ(index)}
                        style={{ cursor: "pointer" }}
                      >
                        <div
                          className="d-flex align-items-center gap-2"
                          style={{ fontSize: 13 }}
                        >
                          <span className="text-primary fw-bold">
                            {isActive ? "▼" : "▶"}
                          </span>
                          <span className="fw-medium">{faq.question}</span>
                        </div>
                      </div>
                      <Collapse in={isActive}>
                        <p
                          className={`ps-4 text-muted `}
                          style={{ fontSize: 12 }}
                        >
                          {faq.answer.replace(/^"|"$/g, "")}
                        </p>
                      </Collapse>
                    </div>
                  );
                })}
              </>
            )}
          </div>
        </Card.Body>
        <div className="justify-content-between p-2 bg-light hstack gap-2">
          <div>
            <Form.Label className="m-0 fw-semibold" style={{fontSize: 12}}>
              ${singleSitePilotAddons?.monthlyPrice} / month
            </Form.Label>
          </div>

          <div className="hstack gap-2">
            <Button size="sm" variant="outline-primary" style={{fontSize: 12}}>
              Chat with us
            </Button>
            <Button size="sm" variant="outline-primary" style={{fontSize: 12}}>
              Schedule a call
            </Button>
            <Button size="sm" variant="primary" style={{fontSize: 12}}>
              Activate Now
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default SitePilotAddonsPreview;
